module.exports = __webpack_public_path__ + "static/media/paperclip.023aee8f.svg";